import 'react-app-polyfill/ie11'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'

import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: '71b4badd-d170-49bd-afce-491be7bd27b1',
  clientToken: 'pub28f8854f91d9e47757c8561ac266840c',
  site: 'datadoghq.com',
  service: 'px-client',
  env: import.meta.env.VITE_DATADOG_ENVIRONMENT,
  version: import.meta.env.VITE_DD_VERSION,
  resourceSampleRate:
    Number(import.meta.env.VITE_DD_RUM_SAMPLE_PERCENT) || 100,
  sampleRate: Number(import.meta.env.VITE_DD_RUM_SAMPLE_PERCENT) || 100,
  allowedTracingOrigins: [
    /https:\/\/.*\.nc-acceptance\.com/,
    /https:\/\/.*\.navigatingcare\.com/,
    'https://nav.care',
  ],
})

createRoot(document.getElementById('root') as HTMLElement).render(<App />)
